export class CategoryPimsModel {
  public categoryPimsId!: number;
  public name!: string;
}
